import React from 'react';
import {
  IonToggle,
  IonGrid,
  IonRow,
  IonCol,
  IonButton,
  IonText
} from '@ionic/react';
import { Card } from '@tremor/react';
import { OCCUPANT_TYPE } from '../../utils/constants';

export default function UnpaidBalancesCard({
  totalUnpaid = 0,
  unpaidCount = 0,
  currency = '',
  handleSendReminders = () => {},
  onView = () => {},
  options = {}
}) {
  const accountLabel = options?.userAccountType === OCCUPANT_TYPE ? 'Tenant' : 'Member';

  return (
    <Card className="mb-3" style={{ borderRadius: '10px' }}>
      <div className="ion-padding" style={{ position: 'relative' }}>
        <h5 className="ion-text-center">
          {accountLabel} Arrears ({currency})
        </h5>        
      </div>
      <IonGrid>
        <IonRow className="ion-justify-content-center ion-text-center">
          <IonCol size="12" sizeMd="8" className="text-center order-1 order-md-1">
            
              <IonText color="primary" style={{ fontSize: '1.8rem' }}>
                {totalUnpaid.toLocaleString('en-US')}
              </IonText>
           
            <p className="ion-margin-top ion-no-margin">
              {unpaidCount} {accountLabel.toLowerCase()}{unpaidCount === 1 ? '' : 's'} with arrears
            </p>
          </IonCol>
          <IonCol size="12" sizeMd="4" className="ion-margin-top text-center order-2 order-md-2">
            <IonButton expand="block" fill="outline" onClick={handleSendReminders}>
              Send Reminders
            </IonButton>
            <IonButton expand="block" fill="outline" className="ion-margin-top" onClick={onView}>
              View Details
            </IonButton>
          </IonCol>
        </IonRow>
      </IonGrid>
    </Card>
  );
} 